import { render, staticRenderFns } from "./MainLedgerDetailList.vue?vue&type=template&id=6839d8a0&scoped=true"
import script from "./MainLedgerDetailList.vue?vue&type=script&lang=js"
export * from "./MainLedgerDetailList.vue?vue&type=script&lang=js"
import style1 from "./MainLedgerDetailList.vue?vue&type=style&index=1&id=6839d8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6839d8a0",
  null
  
)

export default component.exports